import React, { Component } from 'react';
import { connect } from "react-redux";

import { trackingWrapper } from '../../utils/analytics';

const NAMESPACE = '[ IronSource ]';
export const RANDOM_END_RESULT_VIDEOS = 1;

class IronSource extends Component {

	componentDidMount(){
		if (this.props.rewardVideo.ironRV !== null) {
			this.props.rewardVideo.ironRV.show();
		}
	}

	componentDidUpdate(prevProps, prevState) {

		//close ironsource modal
		console.log('<IronSource />', this.props.rewardVideo, prevProps);

		//ironsourse modal close
		if (!this.props.rewardVideo.open && prevProps.rewardVideo.open) {

			this.props.handleVideoOverlayClose(this.props.rewardVideo.complete);

			if (!this.props.rewardVideo.complete && this.props.videoAdType!==null) {
				// tracking
				trackingWrapper('CRgame-skip-ad');
			}
		}

		if (this.props.rewardVideo.complete && !prevProps.rewardVideo.complete) {
			this.props.rewardVideo.ironRV.hide();
		}
	}

	render(){
		return null;
	}
}

const mapStateToProps = state => ({
  rewardVideo: state.rewardVideo
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(IronSource);


// WEBPACK FOOTER //
// ./src/package-reward-ads-overlay/containers/IronSource.js